// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"36d315d0","27":"b7d31a7b","264":"813567b3","272":"bb580780","384":"361e5161","422":"336eae61","631":"a0778577","689":"85acada0","711":"61571c49","787":"b9b8c727","791":"7c4fad42","926":"4ffb3139","958":"1a6bd7d1","975":"6b675716"}[chunkId] + ".chunk.js";
};